import AddIcon from '@mui/icons-material/Add'
import { Button, Card, Grid } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import queryString from 'query-string'
import React, { useCallback, useEffect, useState } from 'react'

import { message } from 'antd'
import { useNavigate } from 'react-router-dom'
import * as XLSX from 'xlsx'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import { MAX_DONWLOAD_PAGE_SIZE } from '../../../../constants/global'
import PageUrls from '../../../../constants/page-urls'
import useAxios, { axiosInstance } from '../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../types/pagination'

import { ITrackingPrintedHistory } from '../../../../types/trackings-printed-history'
import TrackingPrintedHistoryFilter from '../../components/TrackingPrintedHistoryFilter'
import TrackingsPrintedHistoryTable from '../../components/TrackingsPrintedHistoryTable'

const Menus: any[] = []

const HistoryListPage = () => {
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)
  const [isModalCreateCategory, setIsModalCreateCategory] =
    React.useState(false)

  const initFilters = {
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    search: queryStr.search?.length
      ? String(queryStr.search).toLowerCase()
      : undefined,
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : undefined,
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).endOf('day').format()
      : undefined,
  }
  const [searchFilter, setSearchFilter] = useState<any>(initFilters)
  const [filter, setFilter] = useState<any>(initFilters)

  const onFilterChange = useCallback(
    (newFilter: any) => {
      setFilter(newFilter)
    },
    [setFilter],
  )

  const handleSearch = (newFilter: any) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.TrackingPrinted}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(filter)
  }, [])

  const historyList = useAxios<
    PaginationResponseInterface<ITrackingPrintedHistory>
  >({
    method: 'GET',
    url: '/trackings-printed-history',
    params: searchFilter,
  })

  const handleOnDownload = useCallback(async (date: Dayjs) => {
    let loop = true
    let page = 1,
      perPage = MAX_DONWLOAD_PAGE_SIZE
    const data: ITrackingPrintedHistory[] = []
    while (loop) {
      try {
        const result = await axiosInstance.get('/trackings-printed-history', {
          params: {
            ...searchFilter,
            page,
            perPage,
          },
        })
        page++
        if (!result?.data?.records.length) {
          loop = false
          break
        }
        data.push(...result.data.records)
        if (result?.data?.count < perPage) {
          loop = false
          break
        }
      } catch (e) {
        message.warning('เกิดข้อผิดพลาดในการดาวน์โหลดข้อมูลบางส่วน')
        break
      }
    }
    if (!data.length) {
      message.warning('ไม่พบข้อมูล')
      return
    }
    const rows = data?.map((dt: ITrackingPrintedHistory) => {
      return {
        วันที่เพิ่ม: dt.createdAt,
        หมายเลขพัสดุ: dt.orders.map((order: any) => order.tracking).join(', '),
        วันที่แก้ไข: dt.updatedAt,
      }
    })
    const ws = XLSX.utils.json_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    XLSX.writeFile(wb, `tracking-printed-history.xlsx`)
    message.success('ดาวน์โหลดสำเร็จ')
  }, [searchFilter])

  const onUpdateCategorySuccess = useCallback(async () => {}, [filter])

  return (
    <ContentWrapper>
      <Helmet title="รายการประวัติการพิมพ์หมายเลขพัสดุ" />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="ประวัติการพิมพ์หมายเลขพัสดุ"
            routes={Menus}
            descriptions="รายการประวัติการพิมพ์หมายเลขพัสดุ"
            tags={[
              {
                title: 'จำนวน',
                color: 'info',
                value: historyList.data?.count ?? 0,
                classifier: 'รายการ',
              },
            ]}
          />
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}
      >
        <TrackingPrintedHistoryFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
          onDownload={handleOnDownload}
        />
        <TrackingsPrintedHistoryTable
          isLoading={historyList.isLoading}
          data={historyList.data?.records ?? []}
          onUpdateCategorySuccess={onUpdateCategorySuccess}
          filter={{ ...filter }}
          onFilterChange={handleSearch}
          total={historyList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>
  )
}

export default HistoryListPage
